<div class="ion-text-center ion-padding-start ion-padding-end">
  <small>Create an all-in-one experience for your AMOpportunities rotations by building a list of applications where you can submit requirements and payments in one flow.</small>
</div>